import { LayoutHorizontal, LoadingSpinner, Modal } from 'breeze-intelligence-kit';
import { MODAL_MIN_BLOCK_SIZE } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ModalBulkLoading = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Modal.Header, {}), /*#__PURE__*/_jsx(Modal.Body, {
      children: /*#__PURE__*/_jsx(LayoutHorizontal, {
        justifyContent: "center",
        minBlockSize: MODAL_MIN_BLOCK_SIZE,
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          size: "md"
        })
      })
    })]
  });
};